import axios from "axios";
import { $userInfoBd } from "../store/user";
import { IMissions } from "../types/missions";
import { defaultPath } from "./defaultPath";

export const missions = {
    get: async (): Promise<IMissions> => {
        const user_id = $userInfoBd.getState()?.id
        const res = await axios.get(`${defaultPath}tasks/${user_id}`)
        
        return res.data
    },
    check: async (task_id:string) => {
        const user_id = $userInfoBd.getState()?.id;
        const res = await axios.post(`${defaultPath}check_task`,{user_id,task_id});
        
        return res.data;
    },
}